import { render, staticRenderFns } from "./VacationRequestDialog.vue?vue&type=template&id=5a63ebaa&scoped=true"
import script from "./VacationRequestDialog.vue?vue&type=script&lang=js"
export * from "./VacationRequestDialog.vue?vue&type=script&lang=js"
import style0 from "./VacationRequestDialog.vue?vue&type=style&index=0&id=5a63ebaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a63ebaa",
  null
  
)

export default component.exports